export const getStoreLocatorMarkerIcon = (icon) => ({
    url: "data:image/svg+xml;charset=utf-8," + encodeURIComponent(icon),
});
//# sourceMappingURL=getStoreLocatorMarkerIcon.js.map